import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import LikedNamesScreen from "../screens/LikedNamesScreen";
import NameDetailsScreen from "../screens/NameDetailsScreen";

const Stack = createStackNavigator();

const LikedNamesStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerTitleStyle: {
          fontFamily: "Urbanist_700Bold",
          fontSize: 20,
          color: "#333",
        },
        headerStyle: {
          backgroundColor: "#F9FAFB",
        },
      }}
    >
      <Stack.Screen
        name="LikedNames"
        component={LikedNamesScreen}
        options={{ headerTitle: "Liked Names" }}
      />
      <Stack.Screen
        name="NameDetails"
        component={NameDetailsScreen}
        options={{
          headerTitle: "Name Details",
        }}
      />
    </Stack.Navigator>
  );
};

export default LikedNamesStackNavigator;
